import React, { useEffect } from 'react';
import { Container, Grid } from '@mui/material';
import { useGlobal } from '../contexts/GlobalContext';
import { useBuild } from '../contexts/BuildContext';
import { getAvailableData } from '../features_utils';
import RankingQueryColumn from '../ranking/RankingQueryColumn';
import EnrichedResultsColumn from '../components/EnrichedResultsColumn';
import RankingInfoColumn from '../ranking/RankingInfoColumn';

const RankingService = () => {
  const { setCurrentContext } = useGlobal();
  const { hits } = useBuild();

  useEffect(() => {
    const { features, scores } = getAvailableData(hits || []);
    const hasFeaturesOrScores = features.length > 0 || scores.length > 0;
    setCurrentContext({
      product: 'build',
      page: 'ranking',
      ...(hits?.length && { numCandidates: hits.length, hasFeaturesOrScores }),
    });
    return () => setCurrentContext(null);
  }, [hits, setCurrentContext]);

  return (
    <Container maxWidth="xl" sx={{ mt: 2 }}>
      <Grid container spacing={2} sx={{ height: 'calc(100vh - 120px)' }}>
        <Grid size={{ xs: 12, md: 4 }}>
          <RankingQueryColumn />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <EnrichedResultsColumn />
        </Grid>
        <Grid size={{ xs: 12, md: 2 }}>
          <RankingInfoColumn />
        </Grid>
      </Grid>
    </Container>
  );
};

export default RankingService;
